<template>
    <div>
        <v-stepper-step :complete="currentStep > 2" step="2">
            <h3>Step 2</h3>
            <small style="padding-top:5px;"
                >Details of recipient (Address where notification was
                posted)</small
            >
            <div v-show="currentStep == 2" class="text-caption">
                <p>
                    <span class="red--text"><strong>* </strong></span>=
                    Mandatory field
                </p>
            </div>
        </v-stepper-step>
        <v-stepper-content step="2">
            <v-form v-model="recipientFormValid">
                <v-container fluid>
                    <div class="input-wrapper">
                        <input id="stuff" hidden />
                        <label
                            for="stuff"
                            class="fa fa-exclamation input-icon"
                        ></label>
                    </div>

                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="recipient.name"
                            :rules="nameRules"
                            :counter="14"
                            label="RecipientName"
                            placeholder="Customer Name"
                            required
                        >
                            <template #label>
                                <h3 class="black--text">
                                    <span class="red--text"
                                        ><strong>* </strong></span
                                    >Customer Name:
                                </h3>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="recipient.surname"
                            :rules="surnameRules"
                            :counter="20"
                            label="RecipientSurname"
                            placeholder="Customer Surname"
                            required
                        >
                            <template #label>
                                <h3 class="black--text">
                                    <span class="red--text"
                                        ><strong>* </strong></span
                                    >Customer Surname:
                                </h3>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="recipient.companyName"
                            :rules="companyNameRules"
                            :counter="100"
                            label="RecipientCompanyName"
                            placeholder="Company Name"
                        >
                            <template #label>
                                <h3 class="black--text">
                                    <span class="red--text"></span>Company Name:
                                </h3>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" v-if="recipient.companyName">
                        <v-text-field
                            v-model="recipient.vatNumber"
                            :rules="vatNumberRules"
                            label="RecipientVATNumber"
                            placeholder="VAT Number"
                            required
                        >
                            <template #label>
                                <h3 class="black--text">
                                    <span class="red--text"
                                        ><strong>* </strong></span
                                    >VAT Number:
                                </h3>
                            </template>
                        </v-text-field>
                    </v-col>

                    <template>
                        <div>
                            <v-subheader class="pl-0">
                                Search for your address using the address finder or enter it manually below.
                            </v-subheader>

                            <v-card class="mb-4">
                                <v-card-text class="pt-0 pb-2">
                                    <v-autocomplete
                                        v-model="selectedAddress"
                                        :items="addressItems"
                                        :loading="isLoadingAddressData"
                                        :search-input.sync="search"
                                        :menu-props="autocompleteMenuProps"
                                        :messages="showApiError ? [' '] : []"
                                        :hide-no-data="!showNoData"
                                        item-text="Description"
                                        placeholder="Search by Postcode, Locality, House number, House name, etc..."
                                        return-object
                                        clearable
                                        >
                                            <template v-slot:prepend-inner>
                                                <div class="d-flex align-center">
                                                <v-icon v-if="!isLoadingAddressData">mdi-magnify</v-icon>
                                                <v-progress-circular v-else indeterminate size="20" color="primary" />
                                                </div>
                                            </template>

                                            <template v-slot:message>
                                                <div v-if="showApiError" class="d-flex align-center red--text pa-2">
                                                <span style="font-size: 1rem; font-weight: 500;">
                                                    {{ apiError.message }}
                                                </span>
                                                </div>
                                            </template>

                                            <template v-slot:no-data>
                                                <div class="text-caption grey--text pa-2">
                                                {{ noDataText }}
                                                </div>
                                            </template>
                                        </v-autocomplete>
                                </v-card-text>
                            </v-card>
                        </div>
                    </template>

                    <v-col cols="12" md="4">
                        <v-autocomplete
                            :items="localities"
                            label="Locality"
                            item-text="name"
                            item-value="id"
                            placeholder="Select a locality"
                            v-model="recipient.localityId"
                            required
                            :rules="localityRules"
                            @change="updateRecipientAddressLocality"
                        >
                            <template #label>
                                <h3 class="black--text">
                                    <span class="red--text"
                                        ><strong>* </strong></span
                                    >Locality:
                                </h3>
                            </template>
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="recipient.streetName"
                            :rules="streetNameRules"
                            :counter="50"
                            label="RecipientStreetName"
                            placeholder="Street Name"
                            required
                        >
                            <template #label>
                                <h3 class="black--text">
                                    <span class="red--text"
                                        ><strong>* </strong></span
                                    >Street Name:
                                </h3>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="recipient.houseNameNumber"
                            :rules="houseNameNumberRules"
                            :counter="50"
                            label="RecipientHouseNameNumber"
                            placeholder="House Name / Number"
                            required
                        >
                            <template #label>
                                <h3 class="black--text">
                                    <span class="red--text"
                                        ><strong>* </strong></span
                                    >House Name / Number:
                                </h3>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="recipient.postCode"
                            :rules="postCodeRules"
                            label="RecipientPostCode"
                            placeholder="Post Code"
                            required
                        >
                            <template #label>
                                <h3 class="black--text">
                                    <span class="red--text"
                                        ><strong>* </strong></span
                                    >Post Code:
                                </h3>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-autocomplete
                            :items="countries"
                            item-text="dialingCode"
                            item-value="id"
                            placeholder="Country Dialing Code"
                            v-model="recipientPhoneCountryDialingCodeObject"
                            return-object
                            :rules="dialingCodeRules"
                            :filter="customCountryDialingCodeSearch"
                            required
                        >
                            <template slot="selection" slot-scope="data">
                                +{{ data.item.dialingCode }}
                            </template>
                            <template slot="item" slot-scope="data">
                                {{ data.item.name }} (+{{
                                    data.item.dialingCode
                                }})
                            </template>
                            <template #label>
                                <h3 class="black--text">
                                    <span class="red--text"
                                        ><strong>* </strong></span
                                    >Mobile / Telephone Number:
                                </h3>
                            </template>
                        </v-autocomplete>

                        <v-text-field
                            v-model="recipient.phoneNumber"
                            :rules="phoneRules"
                            type="tel"
                            style="padding-top:0"
                            placeholder="Mobile / Telephone Number"
                            required
                        >
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="recipient.email"
                            :rules="emailRules"
                            label="RecipientEmail"
                            type="email"
                            placeholder="E-mail address"
                            required
                        >
                            <template #label>
                                <h3 class="black--text">
                                    <span class="red--text"
                                        ><strong>* </strong></span
                                    >E-mail Address:
                                </h3>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-container>
            </v-form>
            <v-btn
                color="primary"
                @click="goNext()"
                :disabled="!recipientFormValid"
            >
                Next
            </v-btn>
            <v-btn text @click="currentStep = 1"> Back </v-btn>
        </v-stepper-content>
    </div>
</template>

<style></style>

<script>
import validationRules from "../../helpers/ValidationRules";
import axios from "axios";
import _ from "lodash";
import { combineURLs } from "../../helpers/UrlHelpers";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapMissedDeliveryGetters } = createNamespacedHelpers(
    "missedDelivery"
);

export default {
  name: "Step02",
  data() {
    return {
      ...validationRules,
      dataPreloadedFromDb: false,
      recipient: {
        name: "",
        surname: "",
        companyName: "",
        vatNumber: "",
        locality: null,
        localityId: null,
        streetName: "",
        houseNameNumber: "",
        postCode: "",
        phoneCountryDialingCode: 356,
        phoneNumber: "",
        email: "",
      },
      addressSearchResults: [],
      search: null,
      selectedAddress: null,
      isLoadingAddressData: false,
      recipientFormValid: false,
      recipientPhoneCountryDialingCodeObject: {},

      apiError: { show: false, message: "", code: null },
      lastQuery: "",
      searchAttempted: false,

      abortController: null,
    };
  },
  computed: {
        ...mapMissedDeliveryGetters({
        localities: "localities",
        countries: "countries",
        loadedRecipient: "Step02/recipient",
        }),
        currentStep: {
        set(currentStep) {
            this.$store.dispatch("missedDelivery/setCurrentStep", currentStep);
        },
        get() {
            const stepNumber = this.$store.getters["missedDelivery/currentStep"];
            return stepNumber;
        },
        },
        showApiError() {
            return this.apiError?.show && !this.isLoadingAddressData;
        },
        showNoData() {
            return (
            this.searchAttempted &&
            !this.isLoadingAddressData &&
            !this.apiError?.show &&
            (this.addressItems?.length ?? 0) === 0
            );
        },
        noDataText() {
            return this.lastQuery
            ? `No search results found for “${this.lastQuery}”`
            : "No search results found";
        },
        addressItems() {
            return this.addressSearchResults.map((entry) => {
                var addrLine1 = [
                    entry.houseNo,
                    entry.houseName,
                    entry.houseAlpha,
                    entry.flatNo,
                ]
                    .join(" ")
                    .trim();
                var Description =
                    addrLine1 + ", " +
                    entry.street + ", " +
                    entry.locality + " " +
                    entry.postCode + ", " +
                    entry.country;
                return Object.assign({}, entry, { Description, addrLine1 });
            });
        },
      autocompleteMenuProps() {
          // default properties copied from the vuetify-autocomplete docs
          let defaultProps = {
              closeOnClick: false,
              closeOnContentClick: false,
              disableKeys: true,
              openOnClick: false,
              maxHeight: 304,
              offsetY: true,
              offsetOverflow: true,
              transition: false,
          };

          if (this.$vuetify.breakpoint.smAndDown) {
              defaultProps.maxHeight = 185;
          }

          return defaultProps;
    },
  },
  watch: {
    countries() {
      if (this.countries.length > 0) {
        this.recipientPhoneCountryDialingCodeObject = this.countries.find(
          (c) => c.dialingCode == 356
        );
      }
    },
    loadedRecipient() {
        if (
            Object.keys(this.loadedRecipient).length !== 0 &&
            !this.dataPreloadedFromDb
        ) {
            this.recipient = { ...this.loadedRecipient }; //make a "deep" copy
            this.dataPreloadedFromDb = true;
        }
    },
    search: _.debounce(function (val) {
        if (!val) {
            this.addressSearchResults = [];
            this.apiError = { show: false, message: "", code: null };
            this.searchAttempted = false;            // <- NEW
            return;
        }
        // Only search if user input differs from the selected item
        if (!this.selectedAddress || val !== this.selectedAddress.Description) {
            this.lastQuery = val;
            this.fetchAddresses(val);
        }
    }, 500),
    selectedAddress(newSelectedAddress) {
      if (newSelectedAddress != null) {
        this.recipient.houseNameNumber = newSelectedAddress.addrLine1;
        this.recipient.streetName = newSelectedAddress.street;
        this.recipient.postCode = newSelectedAddress.postCode;

        var selectedLocality = this.localities.find(function(l) {
            return (
                l.localityNameOnly.toUpperCase() ===
                newSelectedAddress.locality.toUpperCase() &&
                l.region.toUpperCase() ===
                newSelectedAddress.country.toUpperCase()
            );
        });
        if (selectedLocality) {
          this.recipient.localityId = selectedLocality.id;
          this.recipient.locality = selectedLocality.name;
        }
      }
    },
  },
  beforeDestroy() {
    if (this.abortController) this.abortController.abort();
  },
  methods: {
    goNext() {
      this.recipient.phoneCountryDialingCode = this.recipientPhoneCountryDialingCodeObject.dialingCode;

          this.$store.dispatch(
              "missedDelivery/Step02/setRecipient",
              this.recipient
          );

          this.$store.dispatch("missedDelivery/setCurrentStep", 3);
    },
    updateRecipientAddressLocality(localityId) {
        var locality = this.localities.find(function(l) {
            return l.id === localityId;
        });
        this.recipient.locality = locality.name;
    },
    customCountryDialingCodeSearch(item, queryText) {
      const data = "+" + item.dialingCode + item.name.toLowerCase();
      const searchText = queryText.toLowerCase();

        return data.indexOf(searchText) > -1;
    },

    retrySearch() {
      if (this.lastQuery && !this.isLoadingAddressData) {
        this.fetchAddresses(this.lastQuery);
      }
    },

    async fetchAddresses(query) {
        // Cancel previous request if still running
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        this.isLoadingAddressData = true;
        this.apiError = { show: false, message: "", code: null };
        this.searchAttempted = false;
        this.lastQuery = query;

        try {
            const url = combineURLs(
            process.env.VUE_APP_ADDRESS_FINDER_API_BASE_URL,
            `/v1/address/search?query=${encodeURIComponent(query)}&maxresult=15`
            );

            const res = await axios.get(url, {
            signal: this.abortController.signal,
            timeout: 10000,
            // Treat 404 as "no matches"
            validateStatus: (s) => (s >= 200 && s < 300) || s === 404,
            });

            this.addressSearchResults =
            res.status === 404 ? [] : Array.isArray(res.data) ? res.data : [];

            this.searchAttempted = true;
        } catch (err) {
            // Ignore cancels
            if (axios.isCancel?.(err) || err?.name === "CanceledError" || err?.name === "AbortError") return;

            this.addressSearchResults = [];
            this.searchAttempted = true;

            const status = err?.response?.status ?? null;
            const statusText = err?.response?.statusText ?? "";
            const data = err?.response?.data;
            const serverMsg =
            (typeof data === "string" && data) ||
                data?.message || data?.error || data?.title || data?.detail || null;

            const code = err?.code ?? (status ? `HTTP_${status}` : null);

            const friendly =
                status
                ? `Error ${status}${statusText ? ` ${statusText}` : ""}${serverMsg ? ` — ${serverMsg}` : ""}`
                : (code === "ECONNABORTED"
                    ? "Request timed out. Please try again."
                    : "Something went wrong. Please try again, or complete the form below instead.");

            this.apiError = { show: true, message: friendly, code };
        } finally {
            this.isLoadingAddressData = false;
        }
    }
  },
};
</script>
